import React from 'react'
import styled from 'styled-components'
import { ButtonBase } from './ButtonBase';

export const Button: React.FC<any> = ({ children, ...otherProps }) => {
    return (
        <ButtonBase {...otherProps}>{children}</ButtonBase>
    )
}